import { render, staticRenderFns } from "./AccessWalletBitbox.vue?vue&type=template&id=2de358f4&scoped=true&"
import script from "./AccessWalletBitbox.vue?vue&type=script&lang=js&"
export * from "./AccessWalletBitbox.vue?vue&type=script&lang=js&"
import style0 from "./AccessWalletBitbox.vue?vue&type=style&index=0&id=2de358f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de358f4",
  null
  
)

export default component.exports